"use client";

import { c as _c } from "react/compiler-runtime";
import * as SwitchPrimitive from "@radix-ui/react-switch";
import { cn } from "cn";
import type * as React from "react";
type SwitchProps = React.ComponentProps<typeof SwitchPrimitive.Root> & {
  size?: "sm" | "default";
};

/** A control that turns a single setting on or off, applied immediately. */
function Switch(t0) {
  const $ = _c(11);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  const size = t1 === undefined ? "default" : t1;
  let t2;
  if ($[4] !== className) {
    t2 = cn("peer group/switch inline-flex shrink-0 cursor-pointer items-center", "rounded-full p-0.5 outline-none", "transition-[background-color,box-shadow]", "data-[size=default]:h-4.5 data-[size=default]:w-8", "data-[size=sm]:h-3.5 data-[size=sm]:w-6", "data-[state=checked]:bg-primary data-[state=unchecked]:bg-input", "dark:data-[state=unchecked]:bg-input", "focus-visible:ring-[3px] focus-visible:ring-ring/50", "disabled:pointer-events-none disabled:opacity-50", className);
    $[4] = className;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <SwitchPrimitive.Thumb data-slot="switch-thumb" className={cn("pointer-events-none block rounded-full bg-background transition-transform", "group-data-[size=default]/switch:size-3.5 group-data-[size=sm]/switch:size-2.5", "data-[state=checked]:translate-x-full data-[state=unchecked]:translate-x-0", "dark:data-[state=checked]:bg-primary-foreground dark:data-[state=unchecked]:bg-foreground", "motion-reduce:transition-none")} />;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== props || $[8] !== size || $[9] !== t2) {
    t4 = <SwitchPrimitive.Root data-slot="switch" data-size={size} className={t2} {...props}>{t3}</SwitchPrimitive.Root>;
    $[7] = props;
    $[8] = size;
    $[9] = t2;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}
export { Switch, type SwitchProps };